import { EAccessMenu } from "@/graphql/types";
import { getPermissions } from "@/utils/activity";

export const useCustomerPermissions = () => {
  return getPermissions(EAccessMenu.Customer);
};
